export default "__VITE_ASSET__DYYwDfMB__"